import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'videoAutoPlay';
const DEFAULT_AUTO_PLAY = true;

/**
 * Custom hook for managing video auto-play settings
 * Stores the user's preference in localStorage
 */
function useAutoPlaySettings() {
  const [isAutoPlayEnabled, setIsAutoPlayEnabled] = useState(() => {
    // Load from localStorage on initialization
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved !== null) {
        return JSON.parse(saved);
      }
    } catch (error) {
      // Gracefully fallback to default if localStorage fails
    }
    return DEFAULT_AUTO_PLAY;
  });

  useEffect(() => {
    // Save to localStorage whenever auto-play setting changes
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(isAutoPlayEnabled));
    } catch (error) {
      // Gracefully fallback if localStorage fails
    }
  }, [isAutoPlayEnabled]);

  const toggleAutoPlay = useCallback(() => {
    setIsAutoPlayEnabled(prev => !prev);
  }, []);

  return {
    isAutoPlayEnabled,
    toggleAutoPlay,
    setIsAutoPlayEnabled
  };
}

export default useAutoPlaySettings;
